export default "__VITE_ASSET__B4kwZk7U__"